import { TabDTO } from "utils/domain/extended/tabDTO";
import { InitialClientLoadService } from "./initialClientLoadService";

export interface ApiInitialClientLoad {
    getInitialClientSettings(agentId: string): any;
    setTabs(tabs: TabDTO[]): any;
}

export const initialClientLoadService = new InitialClientLoadService();